var render, staticRenderFns
import script from "./folder_structure.vue?vue&type=script&lang=js"
export * from "./folder_structure.vue?vue&type=script&lang=js"
import style0 from "./folder_structure.vue?vue&type=style&index=0&id=5dd567f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports